// modal.component.ts
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AgentService } from '../agent.service'; // Import your modal service
import { Router } from '@angular/router';
import { any } from 'underscore';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  message: string = '';
  status : boolean = false ;
  showModal: boolean = false;
  private modalSubscription: Subscription; // Store the subscription
  

  constructor(private agentService: AgentService , private route :Router) { }


  ngOnInit(): void {
    this.modalSubscription=this.agentService.getModalMessage().subscribe(obj => {
      if(obj){
      this.message = obj.message;
      this.status = obj.status ;
      this.showModal = true; 
      }// Set showModal to true to display the modal
    });
  }

  closeModal(): void {   
    if (this.status) {
      console.log("navigation to home now ");
     this.route.navigate(["/agent"]);
     this.resetModal();
     this.showModal = false; 
    } else {
      this.showModal = false; // Set showModal to false to hide the modal   
    }

    this.resetModal(); // Reset modal state after closing
    this.agentService.closeModal(); // Call the service method to emit null
  }


// Reset modal state
private resetModal(): void {
  this.message = '';
  this.status = false;
  this.showModal = false; // Set showModal to false to hide the modal
}

ngOnDestroy(): void { // Clean up the subscription
  if (this.modalSubscription) {
    this.modalSubscription.unsubscribe();
  }
}
}

